import store from "./index";
import axios from 'axios'
import { mediaService } from '@/services/mediaService'

export default {
    state: {
        user: null,
        documents: null,
        media: null,
        // userSubscribeProduct: null,
        // userSubscribeCompany: null,
        // subscrInfo: null,
        // userDeals: null,
        // userRatings: null,
        // lotsTurnover: null,
        // agentTurnover: null,
        notPublicFile: null,
        // subscriptionsDisabled: false,
        // subscriptions: [],
    },
    getters: {
        getUser(state) {
            return state.user
        },
        getDocuments(state) {
            return state.documents
        },
        getMedia(state) {
            return state.media
        },
        // getUserSubscribeProduct(state) {
        //   return state.userSubscribeProduct
        // },
        // getUserSubscribeCompany(state) {
        //   return state.userSubscribeCompany
        // },
        // getDeals(state) {
        //   return state.userDeals
        // },
        // getUserRatings(state) {
        //   return state.userRatings
        // },
        // getLotsTurnover(state) {
        //   return state.lotsTurnover
        // },
        // getAgentTurnover(state) {
        //   return state.agentTurnover
        // },
        getNotPublicFile(state) {
            return state.notPublicFile
        },
        // getSubscriptionsDisabled(state) {
        //     return state.subscriptionsDisabled
        // },
        getSubscriptions(state) {
            return state.subscriptions
        },
    },
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setDocuments(state, documents) {
            state.documents = documents
        },
        setMedia(state, media) {
            state.media = media
        },
        setUpdateStatus(state, updateStatus) {
            state.user.updateStatus = updateStatus
        },
        // setUserSubscribesProduct(state, product) {
        //   state.userSubscribeProduct = product
        // },
        // setUserSubscribesCompany(state, company) {
        //   state.userSubscribeCompany = company
        // },
        setUserSubscriptionsDisabled(state, value) {
            state.subscriptionsDisabled = value
        },
        setUserMarketplace(state, value) {
            state.isMarketplace = value
        },
        // setDeals(state, userDeals) {
        //   state.userDeals = userDeals
        // },
        // setUserRatings(state, userRatings) {
        //   state.userRatings = userRatings
        // },
        // setLotsTurnover(state, lotsTurnover) {
        //   state.lotsTurnover = lotsTurnover
        // },
        // setAgentTurnover(state, agentTurnover) {
        //   state.agentTurnover = agentTurnover
        // },
        setNotPublicFile(state, notPublicFile) {
            state.notPublicFile = notPublicFile
        },
    },
    actions: {
        fetchUser({commit, state}, userId) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setUser', response.data)
                commit('setUserSubscriptionsDisabled', response.data.subscriptionsDisabled)
                commit('setUserMarketplace', response.data.isMarketplace)
            }).catch(error => console.log(error))
        },
        fetchUserDocuments({commit, state}, userId) {
            return mediaService.adminGetUserDocuments(userId, {
                is_for_job: true
            }).then(response => {
                commit('setDocuments', response.data)
            }).catch(error => console.log(error))
        },
        fetchUserMedia({commit, state}, userId) {
            return mediaService.adminGetUserDocuments(userId, {
                is_for_job: false,
                is_document: false
            }).then(response => {
                commit('setMedia', response.data)
            }).catch(error => console.log(error))
        },

        moderateUser({commit, state}, user) {
            let body;
            let url;
            body = {
                status: user.status,
                moderationMessage: user.moderationMessage
            }
            url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${user.id}`
            return axios.put(url, body, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                },
            }).then(response => {
                this.dispatch('fetchUser', user.id)
                this.dispatch('fetchUserDocuments', user.id)
            }).catch(error => {
                console.log(error)
            })
        },
        moderateUserUpdates({commit, state}, user) {
            let body;
            let url;
            body = {
                updateStatus: user.updateStatus,
                moderationMessage: user.moderationMessage
            }
            url = `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${user.id}/updates`

            return axios.put(url, body, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                },
            }).then(response => {
                commit('setUpdateStatus', response.data.updateStatus)
                this.dispatch('fetchUser', user.id)
                this.dispatch('fetchUserDocuments', user.id)
            }).catch(error => {
                console.log(error)
            })
        },

        blockUser({commit, state}, userId) {
            let formData = new FormData();
            formData.append('isActive', false)

            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/block`, formData, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                },
            }).then(response => {
                this.dispatch('fetchUser', userId)
                this.dispatch('fetchUserDocuments', userId)
            }).catch(error => {
                console.log(error)
            })
        },
        unblockUser({commit, state}, userId) {
            let formData = new FormData();
            formData.append('isActive', true)

            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/unblock`, formData, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                },
            }).then(response => {
                this.dispatch('fetchUser', userId)
                this.dispatch('fetchUserDocuments', userId)
            }).catch(error => {
                console.log(error)
            })
        },

        userSubscriptionsReverse({commit, state}, userId) {
            console.log(`state.subscriptionsDisabled ${state.subscriptionsDisabled}`)
            return axios.post(
                `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/subscriptions`,
                {
                    subscriptionsDisabled: !state.subscriptionsDisabled
                },
                {
                    headers: {
                        Authorization: `JWT ${store.state.API_TOKEN}`
                    }
                }
            ).then(response => {
                commit('setUserSubscriptionsDisabled', !state.subscriptionsDisabled)
                this.dispatch('fetchUser', userId)
            }).catch(error => {
                console.log(error)
            })
        },
        userMarketplaceReverse({commit, state}, userId) {
            return axios.post(
                `${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/marketplace`,
                {
                    isMarketplace: !state.isMarketplace
                },
                {
                    headers: {
                        Authorization: `JWT ${store.state.API_TOKEN}`
                    }
                }
            ).then(response => {
                commit('setUserMarketplace', !state.isMarketplace)
                this.dispatch('fetchUser', userId)
            }).catch(error => {
                console.log(error)
            })
        },
        uploadUserSubscribes({commit, state}, subscrInfo) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${subscrInfo.userId}/subscriptions`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setUserSubscribesProduct', response.data)
            }).catch(error => console.log(error))
        },
        uploadLotsDeal({commit, state}, lotsDealInfo) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${lotsDealInfo.userId}/deals`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setDeals', response.data)
            }).catch(error => console.log(error))
        },
        uploadUserRatings({commit, state}, userId) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/ratings`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setUserRatings', response.data)
            }).catch(error => console.log(error))
        },
        uploadUserTurnover({commit, state}, userId) {
            return axios.get(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/${userId}/turnover`, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setLotsTurnover', response.data)
            }).catch(error => console.log(error))
        },
        sendTurnover({commit, state}, turnoverInfo) {
            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/users/financial_turnover`, turnoverInfo, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                this.dispatch('uploadUserTurnover', turnoverInfo.user)
            })
                .catch(error => {
                        if (error.response.status == 403) {
                            commit('setErrorText', 'Нет прав для просмотра данного раздела')
                            setTimeout(() => {
                                window.location.href = '/'
                            }, 1500)
                        } else {
                            console.error(error)
                        }
                    }
                );
        },
        changeUserDoc({commit, state}, userDocInfo) {
            return mediaService.adminUploadUserDocument(
                userDocInfo.userId,
                userDocInfo.file,
                userDocInfo.docType
            ).then(response => {
                this.dispatch('fetchUser', userDocInfo.userId)
            })
                .catch(error => {
                    if (error.response.status === 400) {
                        commit('setErrorText', 'Загрузите pdf-документ')
                    }
                })
        },
        deleteUserDoc({commit, state}, userDocInfo) {
            return mediaService.adminDeleteDocument(userDocInfo.docId).then(response => {
                this.dispatch('fetchUser', userDocInfo.userId)
            })
                .catch(error => {
                        if (error.response.status === 403) {
                            commit('setErrorText', 'Нет прав для просмотра данного раздела')
                            setTimeout(() => {
                                window.location.href = '/'
                            }, 1500)
                        } else {
                            console.error(error)
                        }
                    }
                );
        },

        updatePaymentDate({commit, state}, {paymentId, newDate}) {
            let body = {
                payedUntil: newDate
            }
            return axios.put(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/payments/service_payments/${paymentId}`, body, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
            })
                .catch(error => {
                    if (error.response.status == 403) {
                        commit('setErrorText', 'Нет прав для просмотра данного раздела')
                        setTimeout(() => {
                            window.location.href = '/'
                        }, 1500)
                    } else {
                        console.error(error)
                    }
                });
        },
        editMonetaAccount({commit, state}, monetaruInfo) {
            return axios.post(`${store.state.API_HOST}/api/${store.state.API_VERSION}/admin/payments/monetu_ru_account`, monetaruInfo, {
                headers: {
                    Authorization: `JWT ${store.state.API_TOKEN}`
                }
            }).then(response => {
                commit('setErrorText', 'Данные изменены')
            })
                .catch(error => {
                    if (error.response.status == 403) {
                        commit('setErrorText', 'Нет прав для просмотра данного раздела')
                        setTimeout(() => {
                            window.location.href = '/'
                        }, 1500)
                    } else {
                        console.error(error)
                    }
                });
        },
    }
}